var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAergo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.484 4.063c.381 0 .747.151 1.018.42a1.43 1.43 0 0 1 .022 1.99l-3.9 3.901-1.773 1.762a1.44 1.44 0 0 0 1.02 2.457 1.44 1.44 0 0 0 1.017-.421l1.419-1.419.103-.103a1.43 1.43 0 0 1 2.334.465 1.43 1.43 0 0 1-.31 1.56l-10.1 10.1a1.43 1.43 0 0 1-2.025 0 1.44 1.44 0 0 0-2.037 0l-2.128 2.127a1.43 1.43 0 0 1-2.024 0 1.44 1.44 0 0 0-2.035 0l-2.402 2.413a1.44 1.44 0 0 1-2.457-1.017c0-.382.151-.748.421-1.019l7.16-7.16a1.43 1.43 0 0 0-.464-2.336 1.43 1.43 0 0 0-1.56.31l-1.567 1.568a1.44 1.44 0 0 1-2.347-.464 1.43 1.43 0 0 1 .31-1.56L19.397 3.42a1.43 1.43 0 0 1 2.025 0 1.44 1.44 0 0 1 0 2.036L20.278 6.6a1.44 1.44 0 0 0 1.018 2.457 1.44 1.44 0 0 0 1.018-.421l2.024-2.025 2.128-2.126c.27-.27.636-.421 1.018-.421zm1.44 6.162a1.075 1.075 0 1 0 0-2.15 1.075 1.075 0 0 0 0 2.15zM3.076 24.89a1.075 1.075 0 1 0 0-2.151 1.075 1.075 0 0 0 0 2.15z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAergo);
export default __webpack_public_path__ + "static/media/AERGO.982d7d43c38b9b2dc124b5a50221b49b.svg";
export { ForwardRef as ReactComponent };